export default class AdjuntarArchivosModel {
    documento: string;
	prefijo: string;
	numero: number;
	nombreArchivo: string;
	rutaArchivo: string;
	tipo: string;
	texto: string;
}